/**
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// How long to wait after the user stops typing until we trigger the AI inference
export const TYPING_DELAY = 800;
